import br from '@/lang/br';
import us from '@/lang/us';
import es from '@/lang/es';

const messages = {
  br,
  us,
  es,
};

export default messages;



// WEBPACK FOOTER //
// ./src/lang/index.js